import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatsCardProps {
  title: string;
  amount: string;
  subtitle: string;
  icon: BoxIcon;
}
export function StatsCard({
  title,
  amount,
  subtitle,
  icon: Icon
}: StatsCardProps) {
  return <div className="bg-[#1a1a1a] rounded-2xl p-6 border border-[#252525] hover:border-orange-500/30 transition-all duration-300 group" data-id="element-70">
      <div className="flex items-start justify-between mb-4" data-id="element-71">
        <span className="text-sm text-gray-400" data-id="element-72">{title}</span>
        <Icon size={16} className="text-gray-500 group-hover:text-orange-500/50 transition-colors duration-300" data-id="element-73" />
      </div>
      <div className="text-4xl font-bold text-white mb-2" data-id="element-74">{amount}</div>
      <div className="text-xs text-gray-600" data-id="element-75">{subtitle}</div>
    </div>;
}